<template>
    <div class="flex flex-col items-center" :style="colorStyle">
        <Tooltip>
            <template #trigger="tooltipProps">
                <div
                    class="px-1 text-center h-[1.125rem] leading-[1.125rem] overflow-hidden text-clip rounded-xs drop-shadow-[0_0_0.0625rem_rgba(0,0,0,0.3)] focus-visible:outline-offset-2 focus-visible:outline-2 focus-visible:outline-gray-700 text-(--color-text) bg-(--color-background)"
                    :class="editWidgetTextSizeClass"
                    :style="widthStyle"
                    v-bind="tooltipProps"
                    tabindex="0"
                >
                    <template v-if="!displayLongLabel">
                        {{ $t('column-counter-short', { count: props.count }) }}
                    </template>

                    <template v-if="displayLongLabel">
                        {{ $t('column-counter-long', { count: props.count }) }}
                    </template>
                </div>
            </template>

            <template #text>
                <div class="text-center w-full">
                    {{ $t('column-counter-long', { count: props.count }) }}
                </div>
            </template>

            <template #header>
                {{ props.phaseName }}
            </template>
        </Tooltip>

        <div class="w-[0.1875rem] h-[0.3125rem] bg-(--color-background)" />
    </div>
</template>

<script setup lang="ts">
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import { computed } from 'vue';
import { PhaseColor } from '../Timeline.types';
import { getBaseColorForPhaseType, getTextColorForPhaseType } from '../phaseColors';
import { columnWidthInRem, editWidgetTextSizeClass } from '../sharedStyles';

type ColumnCounterProps = {
    count: number;
    phaseName: string;
    phaseColor: PhaseColor;
    displayDoubleWidth: boolean;
    displayLongLabel: boolean;
};

const props = defineProps<ColumnCounterProps>();

const colorStyle = computed(() => {
    return {
        '--color-text': `var(${getTextColorForPhaseType(props.phaseColor)})`,
        '--color-background': `var(${getBaseColorForPhaseType(props.phaseColor)})`,
    };
});

const widthStyle = computed(() => {
    if (props.displayDoubleWidth) {
        return { width: `${columnWidthInRem * 2}rem` };
    } else {
        return { width: `${columnWidthInRem}rem` };
    }
});
</script>
